import React, { ReactNode } from "react";

export const highlightMatch = (text: string, query: string): ReactNode => {
  if (!query) return text;
  const regex = new RegExp(`(${query})`, "gi");

  return text?.split(regex).map((part, index) =>
    regex.test(part) ? (
      <span key={index} style={{ backgroundColor: "yellow" }}>
        {part}
      </span>
    ) : (
      part
    ),
  );
};
